import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arr-down-icon",
  "use": "arr-down-icon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arr-down-icon\">\n    <path d=\"M4.47026 6.19643C4.72977 5.93691 5.15046 5.93668 5.41026 6.19592L8 8.78002L10.5897 6.19592C10.8495 5.93668 11.2702 5.93691 11.5297 6.19643C11.7895 6.45614 11.7895 6.87723 11.5297 7.13694L8 10.6667L4.47026 7.13694C4.21054 6.87722 4.21054 6.45614 4.47026 6.19643Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol